<template>
  <div class="fixed inset-0 flex items-end justify-center px-2 py-6 pointer-events-none sm:p-6 sm:items-end sm:justify-end z-50">
    <div class="max-w-sm w-full">
      <transition-group
        tag="div"
        :enter-active-class="`transform ease-out duration-300 transition ${sortedNotifications.length > 1 ? 'delay-300' : ''}`"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        move-class="transition ease-in-out duration-500"
      >
        <notification
          v-for="(notification, index) in sortedNotifications"
          :key="notification.id"
          :id="notification.id"
          :title="notification.title"
          :message="notification.message"
          :is-error="notification.isError"
          :class="{ 'mt-4': index }"
          @remove="remove(notification.id)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Notification from "@/components/v2/Notification";

export default {
  components: {
    Notification,
  },
  data() {
    return {
      count: 0,
      notifications: [],
    };
  },
  computed: {
    sortedNotifications() {
      return [...this.notifications].slice(0, 4);
    },
  },
  beforeUnmount() {
    this.EventBus.$off("GLOBAL_NOTIFY", this.showNotification);
  },
  created() {
    this.EventBus.$on("GLOBAL_NOTIFY", this.showNotification);
  },
  methods: {
    showNotification(payload) {
      const notification = {
        id: this.count++,
        title: payload.title,
        message: payload.message,
        isError: !!payload.isError,
      };
      this.notifications.push(notification);
      setTimeout(() => this.remove(notification.id), 4000);
    },
    remove(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id);
    },
  },
};
</script>
